module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending-panel"
  }, [_c('h1', {
    staticClass: "md-title pending-panel-title"
  }, [_vm._v("Pending Project Invites")]), _vm._v(" "), (!_vm.userPendingProjectsData) ? _c('div', {
    staticClass: "pending-loading"
  }, [_c('svg', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 200"
    }
  }, [_c('circle', {
    attrs: {
      "fill": "#73D5E3",
      "stroke": "#73D5E3",
      "stroke-width": "15",
      "r": "15",
      "cx": "40",
      "cy": "65"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "cy",
      "calcMode": "spline",
      "dur": "2",
      "values": "65;135;65;",
      "keySplines": ".5 0 .5 1;.5 0 .5 1",
      "repeatCount": "indefinite",
      "begin": "-.4"
    }
  })]), _c('circle', {
    attrs: {
      "fill": "#73D5E3",
      "stroke": "#73D5E3",
      "stroke-width": "15",
      "r": "15",
      "cx": "100",
      "cy": "65"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "cy",
      "calcMode": "spline",
      "dur": "2",
      "values": "65;135;65;",
      "keySplines": ".5 0 .5 1;.5 0 .5 1",
      "repeatCount": "indefinite",
      "begin": "-.2"
    }
  })]), _c('circle', {
    attrs: {
      "fill": "#73D5E3",
      "stroke": "#73D5E3",
      "stroke-width": "15",
      "r": "15",
      "cx": "160",
      "cy": "65"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "cy",
      "calcMode": "spline",
      "dur": "2",
      "values": "65;135;65;",
      "keySplines": ".5 0 .5 1;.5 0 .5 1",
      "repeatCount": "indefinite",
      "begin": "0"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Please wait while we load your invited projects...")])]) : [(_vm.projectsList.length === 0) ? _c('p', {
    staticClass: "pending-empty"
  }, [_vm._v("No pending invites")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.projectsList), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "pending-row"
    }, [_c('span', {
      staticClass: "pending-cover"
    }, [(_vm.showPoster(project)) ? _c('img', {
      attrs: {
        "src": project.posterUrl,
        "alt": project.title
      },
      on: {
        "error": function($event) {
          return _vm.onPosterError(project)
        }
      }
    }) : _c('span', {
      staticClass: "pending-generated",
      style: ({
        backgroundColor: _vm.colorFor(project)
      })
    }, [_vm._v(_vm._s(_vm.initialsFor(project)))])]), _vm._v(" "), _c('span', {
      staticClass: "pending-meta"
    }, [_c('span', {
      staticClass: "pending-title",
      attrs: {
        "title": project.title
      }
    }, [_vm._v(_vm._s(project.title))]), _vm._v(" "), (project.inviterName) ? _c('span', {
      staticClass: "pending-inviter"
    }, [_vm._v("Invited by " + _vm._s(project.inviterName))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "pending-actions"
    }, [_c('md-button', {
      staticClass: "md-mini md-fab pending-action-button",
      on: {
        "click": function($event) {
          return _vm.accept(project)
        }
      }
    }, [_c('md-icon', [_vm._v("person_add")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Join Project")])], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-mini md-fab pending-action-button",
      on: {
        "click": function($event) {
          return _vm.decline(project)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Cancel Invite")])], 1)], 1)])
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd654b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pending-projects.vue
// module id = 1240
// module chunks = 21